import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";

function KpiCard({ label, value, helper }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>
          {value}
        </Typography>
        {helper && (
          <Typography variant="caption" color="text.secondary">
            {helper}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export function FinanceRecurringCards({ recurring }) {
  if (!recurring) return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <KpiCard
          label="Revenue recurrente"
          value={formatPen(recurring.sales_pen)}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <KpiCard
          label="% Recurrente"
          value={`${Number(recurring.share_pct).toFixed(1)}%`}
          helper="Objetivo: 40%"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <KpiCard
          label="Ventas recurrentes"
          value={String(recurring.sales_count)}
        />
      </Grid>
    </Grid>
  );
}
